import React, { useEffect, useState } from "react";
import FormikControl from "../../../../../components/FormikControls/FormikControl";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { Formik, Form ,ErrorMessage} from "formik";
// import { addIndexSchema } from "../../StaticData";
import { useSelector } from "react-redux";
// import { addIndexFace } from "../../Interfaces/Interfaces";
import DYToastMessage from "../../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyButton from "../../../../../components/GlobalComponents/DyButton/DyButton";
// import VerticalAlignments from "../../new/verticalAlignments";
// import { useAddCooperateRequest} from "../../Hooks";
// import CustomeMultiSelect from "../../new/customeMultiSelect";
// import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
import MultiSelect from "../../../../../components/FormikControls/MultiSelect/MultiSelect";
// import { useGetAllBrothersPersonByTeamId, useGetAlBrothersByTeamId } from "../../../IndexManaging/Hooks/Index";
import DyLoadingCircular from "../../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
import { useAddCooperateRequest } from "../../../../OKRManagment/Hooks";
import { useGetAllTeamsByTenantId } from "../../../../IndexManaging/Hooks/Index";
import { useGetAllActivePersonByTenantIdW } from "../../../../Reports/Hooks";
// allIds

const FailureReason = ({
  onSuccess,
  setShowToastMessage,
  setObjectiveAsyncOpState,
  afterSuccess,
  onClose,
  teamIdd,
  periodId,
  keyResultId
}: any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const requestPriorityData = [
    { key: "بالا", value: "Up" },
    { key: "متوسط", value: "Normal" },
    { key: "پایین", value: "Down" },
  ];
  // const { data: teamsOptions, isLoading: teamOPloading } =
  //   useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
  //const { data: categoriesOptionds ,isLoading:getActivePersonLoading} = useGetAllCategoriesTenantId(tenantId);
  const {
    mutate: addObjective,
    data: addObjectiveData,
    isSuccess,
    isLoading,
    isError: isErrorInAddObjective,
  } = useAddCooperateRequest();
  const { data: activePersonData, } =
  useGetAllActivePersonByTenantIdW(tenantId);

const [teamName, setTeamName] = useState<any>({
    teamName: null,
  });
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [teamId, setTeamId] = useState<any>();
  const [addObjError, setAddObjError] = useState<any>(null);
  const [selectedRowData, setSelectedRowData] = React.useState<any>([]);
  const [allTeamsData, setAllTeamsData] = useState<any>(null);
  const { data: teamsOptions, isLoading: teamOPloading } =
  useGetAllTeamsByTenantId(tenantId);
  
  useEffect(() => {
    if(activePersonData !== null && activePersonData !== undefined ){
      setAllTeamsData(activePersonData.map((item:any)=>{
        let{name,id}=item;
        return {year:id,title:name}
      }))
    }
  }, [activePersonData]);

  useEffect(() => {
    if (addObjectiveData) {
      if (addObjectiveData?.data.isSuccess) {
        // setSuccessAddObjective(isSuccess)
        setShowToastMessage(true);
        SetIsSuccess(true);
        SetTMessage(addObjectiveData?.data.metaData.message);
        onSuccess();
        onClose(false);
      } else {
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addObjectiveData?.data.metaData.message);
        setAddObjError(addObjectiveData?.data);
      }
    }
  }, [addObjectiveData]);

  const initialAddObjective = async (data: any) => {
    data.personIds = selectedRowData;
    data.fromTeamId = teamIdd;
    data.periodId = periodId;
    data.keyResultId = keyResultId;
   await addObjective({...data,tenantId:tenantId});
  };

  let changeData  = (teamIddd :any) => {
    if(teamIddd !== null && teamIddd !== undefined && teamIddd !== ''){
      setAllTeamsData(
        activePersonData
          .filter((item: any) => item.teamId?.includes(teamIddd)) 
          .map((item: any) => {
            let { name, id } = item;
            return { year: id, title: name }; 
          })
      );
    }else{
      setAllTeamsData(activePersonData.map((item:any)=>{
        let{name,id}=item;
        return {year:id,title:name}
      }))
    }      
  };

  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
      <Formik
          enableReinitialize
          //validationSchema={addIndexSchema}
          validate={(data) => {
            // let { definitionLevelId, responsibleId, isPublic }: any = data;
            // // console.log(isPublic)
            // setlIsPublic(isPublic);
            // if (isPublic === "برای همه") {
            //   setAllIds([]);
            // }
            // setTeameIdObjects((prev:teamIdsFace)=>({...prev,personIds:[responsibleId]}))
            // setHorzIds((prev:any)=>({...prev,definitionId:definitionLevelId}))
            // console.log(data)
          }}
          initialValues={{ }}
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container>

              <Grid item xs={12} md={12}>
                  <Box padding={"8px"}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">درخواست از تیم</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-selectd"
                        value={values?.toTeamId || ""}
                        label="درخواست از تیم"
                        onChange={(e: any, other: any) => {
                          let { props } = other;
                          let {children} = props;
                          setTeamName(children);
                          let { target } = e;
                          let { value } = target;
                          changeData(value);
                          setTeamId(value);
                          setFieldValue("toTeamId", value);
                        }}
                      >
                        {teamOPloading && (
                          <Box width={"100%"} textAlign={"center"}>
                            <DyLoadingCircular />
                          </Box>
                        )}

                        {teamsOptions &&
                          teamsOptions.map((item: any) => {
                            let { key, value, isCompany } = item;
                            return (
                              <MenuItem
                                key={key}
                                value={value}
                                content={isCompany}
                              >
                                {key}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                { teamId &&  <Grid item xs={12} md={12} >
                      <MultiSelect
                        options={allTeamsData || []}
                        // isLoading={gettenantIndexLoading}
                        //onChangee={setFieldValue}
                        propName='personIds'
                        label={"دریافت کنندگان درخواست"}
                        onChangee={(e: any, other: any) => {
                          // let { target } = e;
                          // let { value } = target;
                          // setParentId(value);
                          setSelectedRowData(other);
                        }}
                      />
                    </Grid>   }

                    <Grid item xs={12} md={12}>
                      <FormikControl
                        control="select"
                        type="select"
                        label="اولویت درخواست"
                        options={requestPriorityData}
                        name="requestPriority"
                        fullWidth
                      />
                    </Grid>

                  <Grid item xs={12} md={12}>
                      <FormikControl
                          control="textField"
                          type="text"
                          label="شرح درخواست"
                          name="description"
                          fullWidth
                          value={values?.description || ''}
                          placeholder="توضیحات (اجباری) 0/300"
                          multiline
                          minRows={5} // تعداد ردیف‌های اولیه که ارتفاع را افزایش می‌دهد
                      />
                  </Grid>


                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                      <Box width={"20%"}>
                            <DyButton
                              disabled={false}
                              // key={i}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={'ثبت'}
                              type={"submit"}
                              onClick={() => { }}
                            />
                          </Box>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Box>
    </>
  );
};

export default FailureReason;